
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $2d95988b81505efb$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["gbgki","index.9c413ca1.js","dCEEN","browserAll.3257d75d.js","b3Ge6","browserAll.94d99915.js","5zD7l","webworkerAll.46cc3324.js","aNM0B","WebGPURenderer.b69fe6f9.js","g8iML","WebGPURenderer.d773cf8b.js","7EYKF","WebGLRenderer.117232ef.js","a5eL9","goalie-down.abd604be.flac","h8zmU","goal.bd7f3e94.flac","8ovxZ","goal-horn.39a2e344.flac","4kjFM","gate-hit.9cdc2f85.flac","2iR9R","game-start.83496793.flac","fFRcO","game-over.3ddc6242.flac","fa6hY","flipper-up.996f7d88.flac","aCEEF","flipper-up-8.d639cd8b.flac","4ZLCG","flipper-up-7.5a7fc9a0.flac","aGEIR","flipper-up-6.e25904e7.flac","htrkx","flipper-up-5.562a495b.flac","epkxp","flipper-up-4.6b675471.flac","7fL1s","flipper-up-3.1fd6b063.flac","cFQLQ","flipper-up-2.b992999f.flac","edwVW","flipper-hit.d13b137b.flac","dQoED","flipper-down.b6adb5d1.flac","21wSj","flipper-down-3.b24262bc.flac","8lk1v","flipper-down-2.de13083f.flac","9IVz9","drain.000bad93.flac","jTO2D","defender-up-2.842f0d1e.flac","ke7cV","defender-up-1.17bad00a.flac","ihX2n","defender-down-3.0d38287b.flac","acsxj","defender-down-2.2818ff07.flac","9dS9p","defender-down-1.6751f6db.flac","lTBtb","buzz.817080bf.flac","hIEeW","button-up-1.ec310530.flac","dAsZI","button-down-1.ebf0976a.flac","3tGV3","bumper-2.a336f61f.flac","acmwx","bumper-1.fd6e5848.flac","jwdBr","boing-2.c25babe6.flac","5w21b","boing-1.0b8f7566.flac","ewusE","ball-rolling.2835d606.flac","jhIQ1","ball-rolling-raw-sm57.20fa3b10.flac","cb1Wg","ball-rolling-raw-at3035.a9979fe0.flac","6O6S8","ball-rolling-3.8b6a2a3b.flac","ldAmi","ball-rolling-2.ee42e2ae.flac","iFSTv","ball-on-ball-raw.da9f5762.flac","3G6IL","ball-on-ball-2.e6564b9f.flac","ckdDm","ball-on-ball-1.fe0fa7f1.flac","7wXBy","ball-drop-1.75900e08.flac","1Lrpx","wall-ao-1.a334bd8b.png","78uGr","wall-1.fcbc61e7.png","QKdio","favicon.86aaaf0c.png"]'));


//# sourceMappingURL=index.runtime.14f18cb0.js.map
